// src/components/UI/Icon/icons.ts

import { ReactComponent as Add } from './icons/add.svg';
import { ReactComponent as ArrowLeft } from './icons/arrow-left.svg';
import { ReactComponent as ArrowRight } from './icons/arrow-right.svg';
import { ReactComponent as ArrowTop } from './icons/arrow-top.svg';
import { ReactComponent as Attachment } from './icons/attachment.svg';
import { ReactComponent as Bird } from './icons/bird.svg';
import { ReactComponent as Cat } from './icons/cat.svg';
import { ReactComponent as Check } from './icons/check.svg';
import { ReactComponent as CheckboxEmpty } from './icons/checkbox-empty.svg';
import { ReactComponent as CheckboxIndeterminate } from './icons/checkbox-indeterminate.svg';
import { ReactComponent as CheckboxCheckedDsiabled } from './icons/checkbox-ticked-disabled.svg';
import { ReactComponent as CheckboxTicked } from './icons/checkbox-ticked.svg';
import { ReactComponent as ChevronDown } from './icons/chevron-down.svg';
import { ReactComponent as ChevronUp } from './icons/chevron-up.svg';
import { ReactComponent as Cross } from './icons/cross.svg';
import { ReactComponent as Cursor } from './icons/cursor.svg';
import { ReactComponent as Dog } from './icons/dog.svg';
import { ReactComponent as Download } from './icons/download.svg';
import { ReactComponent as Email } from './icons/email.svg';
import { ReactComponent as Fish } from './icons/fish.svg';
import { ReactComponent as Hourglass } from './icons/hourglass.svg';
import { ReactComponent as Info } from './icons/info.svg';
import { ReactComponent as Inspect } from './icons/inspect.svg';
import { ReactComponent as MailSent } from './icons/mail-sent.svg';
import { ReactComponent as OpenLink } from './icons/open_link.svg';
import { ReactComponent as Other } from './icons/other.svg';
import { ReactComponent as PersonID } from './icons/person-id.svg';
import { ReactComponent as RadioEmpty } from './icons/radio-empty.svg';
import { ReactComponent as RadioFilled } from './icons/radio-filled.svg';
import { ReactComponent as Remove } from './icons/remove.svg';
import { ReactComponent as Reptile } from './icons/reptile.svg';
import { ReactComponent as SmallMammal } from './icons/small-mammal.svg';
import { ReactComponent as Upload } from './icons/upload.svg';

// Map icon names to React components
export const icons = {
    checkboxEmpty: CheckboxEmpty,
    checkboxTicked: CheckboxTicked,
    checkboxIndeterminate: CheckboxIndeterminate,
    radioFilled: RadioFilled,
    radioEmpty: RadioEmpty,
    add: Add,
    remove: Remove,
    check: Check,
    info: Info,
    chevronUp: ChevronUp,
    chevronDown: ChevronDown,
    arrowTop: ArrowTop,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    upload: Upload,
    download: Download,
    personID: PersonID,
    inspect: Inspect,
    hourglass: Hourglass,
    email: Email,
    cursor: Cursor,
    cross: Cross,
    dog: Dog,
    cat: Cat,
    bird: Bird,
    reptile: Reptile,
    smallMammal: SmallMammal,
    fish: Fish,
    other: Other,
    attachment: Attachment,
    checkboxTickedDisabled: CheckboxCheckedDsiabled,
    MailSent: MailSent,
    OpenLink: OpenLink
};

// Type-safe key for icon names
export type IconName = keyof typeof icons;
